if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";

        // 尝试从页面获取产品ID并设置到表单
        const productIdMeta = document.querySelector('meta[name="product-id"]');
        if (productIdMeta) {
          this.form.dataset.productId = productIdMeta.content;
        } else {
          // 从页面脚本中获取产品ID
          const scriptTags = document.querySelectorAll("script");
          for (let script of scriptTags) {
            if (script.textContent.includes("const currentProductId =")) {
              const match = script.textContent.match(
                /const currentProductId = (\d+);/
              );
              if (match) {
                this.form.dataset.productId = match[1];
                break;
              }
            }
          }
        }
      }

      async onSubmitHandler(event) {
        event.preventDefault();

        // 检查当前是否在main-product1模板中
        const isMainProduct1Template =
          document.querySelector(".product-info-wrap1") !== null;

        // 限购检查 - 仅针对特定产品ID 9921803976986且仅在main-product1模板中
        if (isMainProduct1Template) {
          const RESTRICTED_PRODUCT_ID = 9795860496664;

          // 获取当前产品ID（从表单或页面获取）
          const currentProductId = this.form.dataset.productId
            ? parseInt(this.form.dataset.productId)
            : null;

          // 获取当前表单中的变体ID
          const productIdFromForm = this.form.querySelector('[name="id"]');
          let variantId = null;
          if (productIdFromForm) {
            variantId = parseInt(productIdFromForm.value);
          }

          console.log("Product restriction check:", {
            isMainProduct1Template,
            currentProductId,
            variantId,
            RESTRICTED_PRODUCT_ID,
          });

          // 检查是否是限制的产品
          let isRestrictedProduct = false;

          // 方法1：直接检查产品ID
          if (currentProductId === RESTRICTED_PRODUCT_ID) {
            isRestrictedProduct = true;
            console.log("Restricted product detected via product ID");
          }

          // 方法2：通过变体ID检查
          if (!isRestrictedProduct && variantId) {
            try {
              const variantResponse = await fetch(`/variants/${variantId}.js`);
              const variant = await variantResponse.json();
              console.log("Variant info:", variant);
              if (variant.product_id === RESTRICTED_PRODUCT_ID) {
                isRestrictedProduct = true;
                console.log("Restricted product detected via variant ID");
              }
            } catch (error) {
              console.error("Failed to check variant:", error);
            }
          }

          // 如果是限制产品，检查购物车
          if (isRestrictedProduct) {
            console.log("Starting cart check...");
            try {
              const cartResponse = await fetch("/cart.js");
              const cart = await cartResponse.json();
              console.log("Cart info:", cart);
              const hasRestrictedProduct = cart.items.some(
                (item) => item.product_id === RESTRICTED_PRODUCT_ID
              );
              console.log(
                "Cart already has restricted product:",
                hasRestrictedProduct
              );

              if (hasRestrictedProduct) {
                console.log(
                  "Blocking add: cart already has restricted product"
                );
                // 显示限购提示
                this.showLimitMessage(
                  "This product is already in your cart. Limit 1 per customer."
                );
                // 重置按钮状态
                this.resetButtonState();
                // 完全阻止后续执行
                return;
              } else {
                console.log(
                  "Allowing add: cart does not have restricted product"
                );
              }
            } catch (error) {
              console.error("Failed to check cart:", error);
              // 如果检查失败，为了安全起见，也阻止添加
              this.showLimitMessage(
                "Failed to check cart status. Please try again later."
              );
              this.resetButtonState();
              return;
            }
          } else {
            console.log("Current product is not restricted, adding normally");
          }
        }

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.minicart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.minicart.updateSectionContents();
              return;
            }

            this.minicart.renderContents(response);

            if (window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              this.minicart.open(submitButton);
            }

            const event = new CustomEvent("cart:item-add", {
              detail: {
                items: [response],
                context: this.eventContext,
              },
            });
            document.dispatchEvent(event);

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".button-overlay-spinner").classList.add(
              "hidden"
            );
          });
      }

      // 显示限购提示消息
      showLimitMessage(text) {
        const addToCartContainer =
          this.querySelector(".product-actions-add-to-cart") ||
          this.closest(".product-actions")?.querySelector(
            ".product-actions-add-to-cart"
          ) ||
          this.parentElement;

        if (!addToCartContainer) return;

        // 移除已存在的提示消息
        const existingMessage = addToCartContainer.querySelector(
          ".quantity-limit-message"
        );
        if (existingMessage) {
          existingMessage.remove();
        }

        // 创建新的提示消息
        const messageDiv = document.createElement("div");
        messageDiv.className = "quantity-limit-message";
        messageDiv.style.cssText = `
				background-color: #fee;
				border: 1px solid #fcc;
				color: #c66;
				padding: 10px;
				margin-top: 10px;
				border-radius: 4px;
				font-size: 14px;
				display: block;
			`;
        messageDiv.textContent = text;

        addToCartContainer.appendChild(messageDiv);

        // 5秒后自动隐藏消息
        setTimeout(() => {
          if (messageDiv && messageDiv.parentNode) {
            messageDiv.remove();
          }
        }, 5000);
      }

      // 重置按钮状态
      resetButtonState() {
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");
          const spinner = this.querySelector(".button-overlay-spinner");
          if (spinner) {
            spinner.classList.add("hidden");
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
